import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import globals from '../globals'
import { connect } from 'react-redux'
import DataSource from '../DataSource'
import Button from '../elements/Button'
import LoadingOverlay from './LoadingOverlay'

const RequestHistoryFile = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [inProgress, setInProgress] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [downloadUrl, setDownloadUrl] = useState('')

    useEffect(() => {
        retrieveDownloadUrl()
    }, [props.requests])

    const retrieveDownloadUrl = () => {
        const id = hasFileReady()
        if (id) {
            setHasError(false)
            setDownloadUrl('')
            setIsLoading(true)
            DataSource.postData('/api/postRetrieveGdprFile', {
                serviceId: props.serviceId,
                id: id,
            }, response => {
                globals.pushEvent('HsDownloadHistoryCsv')
                setIsLoading(false)
                if (response.data && response.data[0]) {
                    setDownloadUrl(response.data[0])
                }
            }, error => {
                setIsLoading(false)
                if (error.response.status === 422 || error.response.status === 401) {
                    props.handleExpiredToken()
                } else {
                    setHasError(true)
                    globals.handleError(error.message, { info: 'Error trying to fetch home secure account history file', serviceId: props.serviceId, error: error })
                }
            })
        }
    }

    const handleRequestHistory = event => {
        event.preventDefault()
        setHasError(false)
        setIsLoading(true)
        DataSource.postData(
            '/api/postGdprRequest',
            {
                serviceId: props.serviceId,
                requestType: 'request'
            },
            response => {
                globals.pushEvent('HsRequestHistoryCsv')
                setInProgress(true)
                setIsLoading(false)
            },
            error => {
                setIsLoading(false)
                if (error.response.status === 422) {
                    props.handleExpiredToken()
                } else {
                    setHasError(true)
                    globals.handleError(error.message, { info: 'Error trying to request home secure account history', serviceId: props.serviceId, error: error })
                }
            }
        )

    }

    const hasPendingRequest = () => {
        return props.requests.filter(val => val.fileReady === false).length > 0
    }

    const hasFileReady = () => {
        const files = props.requests.filter(val => val.fileReady === true)
        if (files.length > 0) {
            return files[0].id
        }

        return false
    }

    const Progress = <div className='form-success'>Your request is being processed and will be ready to download here within 48 hours. We'll send you an email when it is ready to download.</div>

    const ButtonContent = () => {
        if (hasFileReady() && downloadUrl) {
            return (
                <React.Fragment>
                    <Button title='Download history CSV' href={downloadUrl} className='mb-3' />
                    <div className='text-center text-lg-left font-small'>
                        A copy of your Home Secure Account History is ready to download. Your account history files will only be available for 30 days from the date requested.
                    </div>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <Button title='Request history CSV' action={handleRequestHistory} className='mb-3' />
                <div className='text-center text-lg-left font-small'>
                    Once requested, a copy of everything your account has stored on Home Secure servers will be available to download here within 48 hours.
                </div>
            </React.Fragment>
        )
    }

    return (
         <LoadingOverlay isLoading={isLoading}>
             <div className='text-center text-lg-left'>
                 {inProgress || hasPendingRequest() ? Progress : ButtonContent()}
                 {hasError && <div className='row-error mt-2'>An error occurred, please try again.</div>}
             </div>
         </LoadingOverlay>
    )
}

RequestHistoryFile.propTypes = {
    serviceId: PropTypes.number.isRequired,
    requests: PropTypes.array.isRequired,
    handleExpiredToken: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    isVerified: state.verifiedUser.isVerified,
    verifiedToken: state.verifiedUser.verifiedToken
})

export default connect(mapStateToProps)(RequestHistoryFile)



// WEBPACK FOOTER //
// ./resources/js/components/RequestHistoryFile.js